module.exports = __webpack_public_path__ + "img/getread-icon-paper.7e0e0631.png";